<div id="<%= dom_id age %>" class="w-full sm:w-auto my-5 space-y-5">
  <div>
    <strong class="block font-medium mb-1">Category:</strong>
    <%= age.category %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Description:</strong>
    <%= age.description %>
  </div>
</div>
